import React, { useState } from 'react';

import styled from '@emotion/styled';

import useWindowEvent from '@zego/hooks/useWindowEvent';
import { primaryColor } from '@zego/theme';

import View from '@zego/components/atoms/View';

const StickyBannerStyling = styled(View)({
  position: 'fixed',
  zIndex: 1,
  bottom: 0,
  width: '100%',
  backgroundColor: primaryColor(11),
});

interface StickyBannerProps {
  children: React.ReactNode;
  testId: string;

  /** the HTML element ID you gave the element you want to start showing the sticky banner on */
  elementIdToShowOn: string;
}

/**
 * @param elementIdToShowOn - the HTML element ID you gave the element you want to start showing the sticky banner on
 * @returns sticky banner
 */
export default function StickyBanner({
  children,
  testId,
  elementIdToShowOn,
  ...rest
}: StickyBannerProps): JSX.Element {
  const [showStickyBanner, setShowStickyQuoteBanner] = useState(false);

  useWindowEvent('scroll', (): void => {
    const section = document.getElementById(elementIdToShowOn);

    if (!section) {
      return;
    }

    const stickyBannerTopOffset = section.offsetTop;

    const showBanner = window.pageYOffset > stickyBannerTopOffset;
    setShowStickyQuoteBanner(showBanner);
  });

  return (
    <StickyBannerStyling
      id="sticky-banner"
      data-testid={testId}
      css={{
        display: showStickyBanner ? 'block' : 'none',
      }}
      {...rest}
    >
      {children}
    </StickyBannerStyling>
  );
}
